import React from 'react';
import { Row, Col, Image, Space, Typography, Card, Grid } from 'antd';
import Img1 from '../../assets/img/dr. Maria Endang Sumiwi, MPH.webp';
import Img2 from '../../assets/img/Dr Mrunel Shetye.webp';
import Img3 from '../../assets/img/Janice Green.webp';
import Img4 from '../../assets/img/Hsu, Yu yun.webp';
import Img5 from '../../assets/img/Tiina Simola.webp';
import './Home.css';

const { useBreakpoint } = Grid;
const { Text } = Typography;

const defaultSpeakers = [
  {
    name: 'Asc. Prof. Theo Bodin',
    url: 'https://scholar.google.com/citations?user=qDjUGgkAAAAJ&hl=id&oi=ao',
    affiliation: '(Karolinska Institute, Swedish)',
    quote: '"Reducing Negatives Effect of Precarious Employment in Developing Countries"',
  },
  {
    name: 'Prof. Vidhya Venugopal',
    url: 'https://scholar.google.com/citations?user=qgS36BsAAAAJ&hl=id&oi=ao',
    affiliation: '(Sri Ramachandra Institute, India)',
    quote: '"The Effect of Air Pollution on Public Health and Social Life"',
  },
  {
    name: 'Prof. Erwin Faller',
    url: 'https://scholar.google.com/citations?hl=id&user=7psN6ZgAAAAJ',
    affiliation: '(San Pedro College, Philippine)',
    quote: '"Current Issue in Tourism: Lessons Learned From Pandemic Diseases Preparedness"',
  },
  {
    name: 'dr. Anna Suraya, Ph.D',
    url: 'https://scholar.google.com/citations?hl=id&user=6pRs-RwAAAAJ',
    affiliation: '(Universitas Binawan, Indonesia)',
    quote: '"Protect People From Asbestos Exposure During Disaster"',
  },
  {
    name: 'Dr. Ir. Yaya Suryana, M.Eng., IPU*',
    url: 'https://scholar.google.com/citations?hl=id&user=129b7MEAAAAJ',
    affiliation: '(Indonesia Artificial Intelligence Society, Indonesia)',
    quote: '"AI in Public Health"',
  },
];

const speakerImages = [Img1, Img2, Img3, Img4, Img5];
const speakerImageStyles = [
  { objectFit: 'cover', objectPosition: '0 -10px', borderRadius: 100, backgroundColor: '#F2F2F2' },
  { objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' },
  { objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' },
  { objectFit: 'cover', objectPosition: '0 -20px', borderRadius: 100, backgroundColor: '#F2F2F2' },
  { objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' },
];

function Speakers({ content }) {
  const { xs, xxl } = useBreakpoint()

  const speakers = Array.isArray(content) && content.length ? content : defaultSpeakers;

  const renderSpeakerCard = (speaker, index) => {
    const name = String(speaker?.name ?? '');
    const url = speaker?.url ? String(speaker.url) : '';
    const affiliation = speaker?.affiliation ? String(speaker.affiliation) : '';
    const quote = speaker?.quote ? String(speaker.quote) : '';
    const topic = speaker?.topic ? String(speaker.topic) : '';
    const topicText = topic || quote;

    const imageIndex = index % speakerImages.length;
    const imageSrc = speakerImages[imageIndex];
    const imageStyle = speakerImageStyles[imageIndex] || speakerImageStyles[0];

    return (
      <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
        <Space direction='vertical' size={16} align='center'>
          <Image
            width={150}
            height={150}
            src={imageSrc}
            preview={false}
            style={imageStyle}
          />
          <Space direction='vertical' size={0} align='center'>
            {url ? (
              <a href={url} target="_blank" rel="noreferrer">
                <Text className='link-name' strong style={{ fontSize: 15 }}>{name}</Text>
              </a>
            ) : (
              <Text className='link-name' strong style={{ fontSize: 15 }}>{name}</Text>
            )}
            {affiliation ? (
              <Text type='secondary' style={{ fontSize: 13 }}>{affiliation}</Text>
            ) : null}
            {topicText ? (
              <Text italic type='secondary' style={{ fontSize: 13 }}>{topicText}</Text>
            ) : null}
          </Space>
        </Space>
      </Card>
    );
  };

  return (
    <React.Fragment>
      {
        xs ?
          <Row justify="space-around" align="middle" gutter={[0,16]} style={{ backgroundColor: '#F2F2F2', padding: 16, textAlign: 'center' }}>
            <Col span={24}>
              <Text style={{ fontSize: 30, fontWeight: 'bold' }}>Speakers</Text>
            </Col>
            {speakers.map((speaker, index) => (
              <Col key={index} span={24}>
                {renderSpeakerCard(speaker, index)}
              </Col>
            ))}
          </Row>
        :
          <Row justify="space-around" align="middle" gutter={[64,64]} style={{ backgroundColor: '#F2F2F2', padding: xxl ? '50px 300px 70px 300px' : '50px 50px 70px 50px', textAlign: 'center' }}>
            <Col span={24}>
              <Text style={{ fontSize: 30, fontWeight: 'bold' }}>Speakers</Text>
            </Col>
            {speakers.slice(0, 3).map((speaker, index) => (
              <Col key={index} span={8}>
                {renderSpeakerCard(speaker, index)}
              </Col>
            ))}
            <Col span={4}></Col>
            {speakers.slice(3, 5).map((speaker, offsetIndex) => {
              const index = offsetIndex + 3;
              return (
                <Col key={index} span={8}>
                  {renderSpeakerCard(speaker, index)}
                </Col>
              );
            })}
            <Col span={4}></Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Speakers